import { Result } from '@ecoflow/ef-ui';
import { ComponentProps } from 'react';
import { t } from '@lingui/macro';

export default function AntdResult(props: ComponentProps<typeof Result>) {
    const subTitle = props.subTitle ? props.subTitle : <span style={{ color: 'rgba(0,0,0,0.5)' }}>{t`No data`}</span>;

    return (
        <Result
            icon={<CustomIcon />}
            style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', color: 'red' }}
            {...props}
            subTitle={subTitle}
        />
    );
}

function CustomIcon() {
    return (
        <svg width="162" height="162" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <path d="M81 0c44.735 0 81 36.265 81 81s-36.265 81-81 81S0 125.735 0 81 36.265 0 81 0z" id="b" />
                <path
                    d="M-19 175.986C8.248 115.81 29.924 85.724 46.027 85.724c23.306 0 21.57 31.764 37.068 31.764C98.594 117.488 92.82 57 120.64 57c18.546 0 43.333 39.662 74.36 118.986H-19z"
                    id="a"
                />
                <mask id="d" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="-2" y="-2" width="218" height="122.986">
                    <path fill="#fff" d="M-21 55h218v122.986H-21z" />
                    <use xlinkHref="#a" />
                </mask>
            </defs>
            <g fill="none" fillRule="evenodd">
                <mask id="c" fill="#fff">
                    <use xlinkHref="#b" />
                </mask>
                <use fill="#E8EEF8" xlinkHref="#b" />
                <g strokeDasharray="2,2" mask="url(#c)" fill="#FFF" fillOpacity=".404" stroke="#7096D4" strokeOpacity=".228" strokeWidth="4">
                    <use mask="url(#d)" xlinkHref="#a" />
                </g>
                <path
                    d="m61.527 44.571 68.736 21.303a1 1 0 0 1 .258 1.787l-11.812 7.854-32.203-15.087a.5.5 0 0 0-.514.852l25.332 19.212.001 14.344a1 1 0 0 1-1.69.724l-8.66-8.25-14.216 9.455a1 1 0 0 1-.054.034l-.056.03a1 1 0 0 1-1.34-.452L60.335 45.97a1 1 0 0 1 1.192-1.399z"
                    fill="#FFF"
                    mask="url(#c)"
                />
                <path d="M100.676 87.454 111.326 81v13.704a1 1 0 0 1-1.666.747l-8.984-7.997z" fill="#C7D4EA" mask="url(#c)" />
                <path d="m118.806 75.503-7.747 5.7-25.231-20.15a.4.4 0 0 1 .418-.675l32.56 15.125z" fill="#E8EEF8" mask="url(#c)" />
            </g>
        </svg>
    );
}
